/* global document, window */
import React, { useCallback, useContext } from 'react';
import { Button } from 'react-bootstrap';
import { FaComments } from 'react-icons/fa';
import constants from '../constants.json' assert { type: 'json' };
import '../styles/AdditionalHeaderLinks.css';
import Cart from './Cart';
import AppContext from './context/AppContext';
import propTypes from 'prop-types';
import { Link } from 'react-router-dom';
import useIsRendered from '../hooks/useIsRendered';


const AdditionalHeaderLinks = ({ user, isMobile, showStickyHeader }) => {
    const { appContext } = useContext(AppContext);
    const { isRendered } = useIsRendered();

    const appConfig = appContext.config.themeConfig;

    /** Handlers */
    const handleAuthClick = useCallback(() => {
        if (isRendered) {
            window.location.assign(`/${user ? 'logout' : 'login'}`);
        }
    }, [user, isRendered]);

    const handleShowChatClick = useCallback(() => {
        const {
            FORM_IFRAME_ID,
            BUTTON_IFRAME_ID,
            INPUT_SELECTOR,
            TEXTAREA_SELECTOR,
            BUTTON_SELECTOR,
        } = constants.ZENDESK;

        const zendeskFormIframe = document.querySelector(FORM_IFRAME_ID);
        const zendeskButtonIframe = document.querySelector(BUTTON_IFRAME_ID);

        if (zendeskFormIframe) {
            const inputs = zendeskFormIframe.contentDocument.querySelectorAll(`${INPUT_SELECTOR}, ${TEXTAREA_SELECTOR}`);
            for (const input of inputs) {
                if (!input.value) {
                    input.focus();
                    break;
                }
            }
        } else if (zendeskButtonIframe) {
            const zendeskButton = zendeskButtonIframe.contentDocument.querySelector(BUTTON_SELECTOR);
            const messageInput = zendeskButtonIframe.contentDocument.querySelector(INPUT_SELECTOR);

            if (messageInput) {
                messageInput.focus();
            } else if (zendeskButton) {
                zendeskButton.click();
            }
        }
    }, []);

    /** Render */
    return (
        <div
            className={'additional-header-links--container'}>
            <div
                className={'additional-header-links--subcontainer-left'}>
                <Link
                    to={'/myaccount.asp'}>My Account</Link>
                {!user && (
                    <>
                        <Link
                            className={'additional-header-links--signin'}
                            onClick={handleAuthClick}>
                        Sign in
                        </Link>
                        or
                        <Link
                            to={'/register'}>
                            Create an account
                        </Link>
                    </>
                )}
                {user && (
                    <Link
                        onClick={handleAuthClick}>
                        Sign Out
                    </Link>
                )}
                <Link
                    to={appConfig?.returnsPolicy?.url}>Returns</Link>
                <Link
                    to={appConfig?.shippingPolicy?.url}>Shipping</Link>
                <Link
                    to={appConfig?.requestItem?.url}>Request an Item</Link>
            </div>
            <div
                className={'additional-header-links--subcontainer-right'}>
                <Button
                    size={'sm'}
                    variant={'danger'}
                    className={'additional-header-links--button'}
                    onClick={handleShowChatClick}
                >
                    <FaComments
                        size={'16px'} />
                    CHAT NOW
                </Button>
                {!isMobile && !showStickyHeader && <Cart /> }
            </div>
        </div >
    );
};

AdditionalHeaderLinks.propTypes = {
    user: propTypes.object,
    isMobile: propTypes.bool,
    showStickyHeader: propTypes.bool,
};

export default AdditionalHeaderLinks;
